
const normalizePath = (value) => {
  if (!value) return ''
  let path = String(value).trim()
  const absolute = path.match(/^https?:\/\/[^/]+(\/[^?#]*)?/i)
  if (absolute) path = absolute[1] || '/'
  path = path.split('?')[0].split('#')[0]
  if (!path.startsWith('/')) path = `/${path}`
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1)
  return path
}

export default {
  name: 'SectionsButtonPillsNavigation',
  props: {
    buttonPillsNavigation: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    visibleItems() {
      const items =
        (this.buttonPillsNavigation && this.buttonPillsNavigation.items) || []
      return items.filter((item) => item && item.enabled !== false && item.label)
    },
    currentPath() {
      return normalizePath(this.$route && this.$route.path)
    },
  },
  methods: {
    isActive(item) {
      if (!item || item.external) return false
      const path = normalizePath(item.url)
      return path !== '' && path === this.currentPath
    },
    linkTo(item) {
      return normalizePath(item && item.url) || '/'
    },
  },
}
